/* --- YarnLoving variant swatches --- */
(function () {
  console.log("🧶 Variant-swatches script kører!");

  // Hent billeder baseret på produktets handle
  const handle = window.location.pathname.split("/products/")[1]?.split("/")[0];
  if (!handle) return console.warn("❌ Ingen produkt-handle fundet");

  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      const map = {};
      product.variants.forEach(v => {
        if (v.option1 && v.featured_image)
          map[v.option1.toLowerCase().trim()] = v.featured_image.src;
      });

      document.querySelectorAll('fieldset[name*="Farve"] label, fieldset[name*="farve"] label')
        .forEach(label => {
          const val = label.innerText?.toLowerCase().trim();
          if (map[val]) {
            label.style.backgroundImage = `url(${map[val]})`;
            label.style.backgroundSize = "cover";
            label.style.backgroundPosition = "center";
            label.style.opacity = "1";
          }
        });

      console.log("🎨 Swatch-billeder opdateret:", Object.keys(map).length);
    })
    .catch(err => console.warn("❌ Fejl ved hentning af produktdata:", err));
})();
